export interface CharacterState {
  x: number;
  z: number;
  yaw: number;
  animTime: number;
}

export const createCharacter = (x = 0, z = 0, yaw = 0): CharacterState => ({
  x,
  z,
  yaw,
  animTime: 0,
});
